import request from '@/http/request';

// 获取待派发工单统计数据
export function getPendingDispatchStatistics() {
  return request({
    url: '/api/v1/ops/pending_dispatch_statistics',
    method: 'get',
  });
}

// 获取超时工单统计数据
export function getOvertimeStatistics() {
  return request({
    url: '/api/v1/ops/timeout_statistics',
    method: 'get',
  });
}

// 获取质量问题工单统计数据
export function getQualityIssueStatistics() {
  return request({
    url: '/api/v1/ops/quality_issue_statistics',
    method: 'get',
  });
}

// 获取服务器搬迁统计数据
export function getServerRelocationStatistics() {
  return request({
    url: '/api/v1/ops/server_relocation_statistics',
    method: 'get',
  });
}


export function tpcDeploymentStatistics() {
    return request({
      url: '/api/v1/ops/tpc_deployment_statistics',
      method: 'get',
    });
  }

  // 获取服务器搬迁人均统计数据
export function getServerStatistics() {
  return request({
    url: '/api/v1/ops/server_statistics',
    method: 'get',
  });
}
// 获取网络变更统计数据
export function getNetworkChangeStatistics() {
  return request({
    url: '/api/v1/ops/network_change_statistics',
    method: 'get',
  });
}

// 获取TPC部署人均统计数据
export function getTPCDeploymentPerPersonStatistics() {
  return request({
    url: '/api/v1/ops/tpc_statistics',
    method: 'get',
  });
}
// 获取网络变更人均统计数据
export function getNetworkChangePerPersonStatistics() {
  return request({
    url: '/api/v1/ops/network_change_per_person_statistics',
    method: 'get',
  });
}
